module.exports = __webpack_public_path__ + "img/product-card-05.2ef7ea5.webp";